// extracted by mini-css-extract-plugin
module.exports = {"window":"InputWindow_window__2Z10P","contentContainer":"InputWindow_contentContainer__3HPK8","windowTitle":"InputWindow_windowTitle__3uiII"};